var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8889 0.485878C12.8888 0.565938 12.8676 0.644756 12.8272 0.71539C12.7868 0.786023 12.7284 0.846308 12.6571 0.89094C12.6411 0.900352 11.0838 1.88217 10.5803 3.0399C10.2907 3.7466 10.1658 4.50277 10.2142 5.258H11.9938C12.0953 5.25811 12.1945 5.28577 12.2793 5.33762C12.3642 5.38947 12.431 5.46326 12.4716 5.54995C12.5122 5.63665 12.5248 5.73251 12.508 5.8258C12.4911 5.91909 12.4455 6.00578 12.3766 6.07526L8.64128 9.84414C8.59242 9.8933 8.53321 9.93252 8.46733 9.95934C8.40148 9.98616 8.33037 10 8.25849 10C8.18663 10 8.11553 9.98616 8.04964 9.95934C7.98379 9.93252 7.92456 9.8933 7.87569 9.84414L4.13861 6.07526C4.06978 6.00578 4.02414 5.91909 4.00725 5.8258C3.9904 5.73251 4.00305 5.63665 4.04363 5.54995C4.08426 5.46326 4.15106 5.38947 4.2359 5.33762C4.32077 5.28577 4.41995 5.25811 4.5214 5.258H6.26901C6.44964 2.63127 8.12139 0 12.3669 0C12.5053 0 12.6381 0.051293 12.736 0.142596C12.8339 0.233898 12.8889 0.356757 12.8889 0.485878Z",
    fill: "url(#paint0_linear_3102_27893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.827605 8.27588C1.28468 8.27588 1.65521 8.64641 1.65521 9.10348V13.5172C1.65521 13.9743 2.02573 14.3448 2.48279 14.3448H13.5173C13.9743 14.3448 14.3449 13.9743 14.3449 13.5172V9.10345C14.3449 8.64638 14.7154 8.27588 15.1724 8.27588C15.6295 8.27588 16 8.64638 16 9.10345V13.5172C16 14.8884 14.8885 16 13.5173 16H2.48279C1.11161 16 3.55244e-05 14.8884 3.55244e-05 13.5172L0 9.10349C-2.80612e-06 8.64641 0.370529 8.27588 0.827605 8.27588Z",
    fill: "url(#paint1_linear_3102_27893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3102_27893",
    x1: 8.00002,
    y1: 0,
    x2: 8.00002,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3102_27893",
    x1: 8.00002,
    y1: 0,
    x2: 8.00002,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.e0fb088aeafdd87a9ded37f166cd7160.svg";
export { ForwardRef as ReactComponent };